@if (loading) {
    <p-progressSpinner class="ps">
    </p-progressSpinner>
}
@else {
    <ng-content>
    </ng-content>
}
